import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { history } from "./../../_helpers";
import "../Front/front.scss";
import Footer from "../Other/Footer";
import MatureContentPage from "../Other/MatureContentGuidelines";
import LoginPage from "../Login/LoginPage";
import Page404 from "../Other/Page404";
import ForgotPassword from "../Login/ForgotPassword";
import { ScrollRestoration } from "../Other/ScrollRestoration";
import Cart from "../Dashboard/ShoppingCart/Cart";
import PrivateRoute from "../../Components/PrivateRoute";
function Front(props) {
  // Set token for server side information
  const [token, setToken] = useState();
  const { i18n } = useTranslation();
  const [initialized, setInitialized] = useState(false);
  const [manageCookie, setManageCookie] = useState(false);
  const [manageAnimation, setManageAnimation] = useState(true);
  const getCookie = localStorage.getItem("cookie");

  const handleAnimation = () => {
    setManageAnimation(true);
  };

  const handleCookie = () => {
    setManageAnimation(false);
  };

  useEffect(() => {
    if (getCookie === "false") {
      setManageCookie(false);
    } else {
      setTimeout(() => {
        handleCookie();
        setManageCookie(true);
      }, 15000);
    }
  }, []);

  // useEffect(() => {
  //   if (!initialized) {
  //     localStorage.setItem(
  //       "language",
  //       localStorage.getItem("language") || "en"
  //     );
  //     i18n.changeLanguage(localStorage.getItem("language") || "en");
  //     setInitialized(true);
  //   }

  //   // window.addEventListener("scroll", () => {
  //   //   setScroll(window.scrollY > 70);
  //   // });
  // }, [i18n, initialized]);

  //  if(!token) {
  //    return <LoginPage setToken={setToken} />
  // }

  if (!token) {
    return (
      <div className="front-panel">
        {/* {!props.mainLogin && (
          <OverlayContainer>
            <MainLoginOverlay />
          </OverlayContainer>
        )} */}

        {/*
                <div className={scroll ? "showAd" : "hide"}>
                    <Advert />
                </div>
                 */}

        <Router history={history}>
          {/* <TopBar /> */}

          <ScrollRestoration />
          <Switch>
            <Route exact path="/forget-password" component={ForgotPassword} />
            <Route path="/" component={LoginPage} />
            <Route exact component={Page404} />
            <Route path="/mature-guidelines" component={MatureContentPage} />
          </Switch>

          <Footer />
          {/* {manageCookie ? (
            <Cookies
              manageAnimation={manageAnimation}
              handleAnimation={handleAnimation}
            />
          ) : null} */}
        </Router>
        {/* <CustomAlert /> */}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { mainLogin } = state.mainlogin;
  return {
    mainLogin,
  };
}

const connectedApp = connect(mapStateToProps)(Front);
export default connectedApp;
